import { SendHorizontal } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/modules/ui/components/button/Button';
import { Textarea } from '@/modules/ui/components/textarea/Textarea';

interface MessageComposerProps {
  isSending: boolean;
  onSend: (content: string) => void;
}

export const MessageComposer = ({
  onSend,
  isSending,
}: MessageComposerProps) => {
  const [newMessage, setNewMessage] = useState('');

  const handleSend = () => {
    onSend(newMessage);
    setNewMessage('');
  };

  return (
    <div className="p-4">
      <div className="flex w-full gap-2">
        <Textarea
          rows={3}
          value={newMessage}
          placeholder="Type your message..."
          className="flex-1"
          onChange={(e) => setNewMessage(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSend();
            }
          }}
        />
        <Button
          variant="ghost"
          onClick={handleSend}
          loading={isSending}
          className="h-auto self-stretch"
        >
          <SendHorizontal size={18} />
          Send
        </Button>
      </div>
    </div>
  );
};
